import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './slices/auth.slice';
import { profileSlice } from './slices/profile.slice';
import { alertSlice } from './slices/alert.slice';
import { taxProfileSlice } from './slices/taxProfile.slice';
import { cartSlice } from './slices/cart.slice';
import { productsSlice } from './slices/products.slice';
import { invocingSlice } from './slices/invoicing';
import { plansUISlice } from './slices/plansUI.slice';
import { plansPreferencesSlice } from './slices/plansPreferences.slice';
import { plansDataSlice } from './slices/plansData.slice';
import { uiSlice } from './slices/ui.slice';
import { satLinkingUISlice } from './slices/satLinkingUI.slice';
export const store = configureStore({
	reducer: {
		ui: uiSlice.reducer,
		auth: authSlice.reducer,
		profile: profileSlice.reducer,
		alert: alertSlice.reducer,
		taxProfile: taxProfileSlice.reducer,
		cart: cartSlice.reducer,
		productList: productsSlice.reducer,
		invocing: invocingSlice.reducer,
		plansUI: plansUISlice.reducer,
		plansPreferences: plansPreferencesSlice.reducer,
		plansData: plansDataSlice.reducer,
		satLinkingUI: satLinkingUISlice.reducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
